export default __webpack_public_path__ + "static/media/topBanner2.9a4fcd09.png";